module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "cats"
  }, [_c('div', {
    staticClass: "headings"
  }, [_c('h2', [_vm._v("Our "), _c('span', {
    staticClass: "not-on-mobile"
  }, [_vm._v("Unique and Common")]), _vm._v(" Kitties "), _c('span', {
    staticClass: "not-on-mobile"
  }, [_vm._v(" - " + _vm._s(_vm.cats.length) + " entries")])]), _vm._v(" "), _c('h2', [_vm._v("Sort by:\n      "), _c('span', {
    staticClass: "sort",
    class: {
      active: _vm.uniqueSort
    },
    on: {
      "click": function($event) {
        _vm.sortByUnique()
      }
    }
  }, [_vm._v("Unique")]), _vm._v("\n      |\n      "), _c('span', {
    staticClass: "sort",
    class: {
      active: _vm.commonSort
    },
    on: {
      "click": function($event) {
        _vm.sortByCommon()
      }
    }
  }, [_vm._v("Common")])])]), _vm._v(" "), _c('div', {
    ref: "catref"
  }, _vm._l((_vm.cats), function(cat) {
    return _c('cat', {
      attrs: {
        "cat": cat
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33f716f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cats/Index.vue
// module id = 126
// module chunks = 2